var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('EventSectionFields'),_c('Divider',{staticClass:"mv-30"}),_c('LocaleSectionFields'),_c('Divider',{staticClass:"mv-30"}),_c('DatesSectionFields',{class:{ 'disabled-container': _vm.isEdit }}),(_vm.isAgency && !_vm.isEdit)?_c('HirerSectionFields'):(!_vm.isEdit)?_c('ContactSectionFields'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }